import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "option"],
  _excluded2 = ["$help", "$isCustomComponent", "$toggleable"];
import { Component } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { RESTRICTED_OPTION_PROPS, RESTRICTED_OPTION_TOOLTIP } from 'customer-data-filters-ui/utils/fieldLevelPermissions';
import { jsx as _jsx } from "react/jsx-runtime";
class FilterOperatorPropertyInputOption extends Component {
  render() {
    const _this$props = this.props,
      {
        children,
        option
      } = _this$props,
      rest = _objectWithoutPropertiesLoose(_this$props, _excluded);
    const domProps = _objectWithoutPropertiesLoose(rest, _excluded2);

    // UISelect only passes valid properties on the option object limiting our ability to pass in a tooltipMessage for when items are disabled
    // so we have to check the icon as a workaround
    // Disabled with no icon - can't compare to itself
    // Disabled with Block icon - sensitive property you have access to, others might not
    // Disabled with Hide icon - sensitive property you do not have access to
    let tooltipMessage = 'customerDataFiltersUI.customerDataFilters.FilterOperatorPropertyInput.titleCantCompareToItself';
    if (option.icon === 'block') {
      tooltipMessage = 'customerDataFiltersUI.customerDataFilters.FilterOperatorPropertyInput.sensitiveDataTooltip';
    } else if (option.icon === RESTRICTED_OPTION_PROPS.icon) {
      tooltipMessage = RESTRICTED_OPTION_TOOLTIP;
    }
    return /*#__PURE__*/_jsx("span", Object.assign({}, domProps, {
      children: /*#__PURE__*/_jsx(Tooltip, {
        disabled: !option.disabled,
        placement: "right",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: tooltipMessage
        }),
        children: /*#__PURE__*/_jsx("span", {
          children: children
        })
      })
    }));
  }
}
export default FilterOperatorPropertyInputOption;